<template>
    <div class="listContent">
        <section>
            <a-form class="headForm" labelAlign="left" disabled>
                <p class="section-title">成果基本信息</p>
                <a-row :gutter="24">
                    <a-col :span="6">
                        <a-form-item label="成果编号">
                            <a-input v-model="rmpResult.no" disabled placeholder="请输入成果编号" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果名称">
                            <a-input v-model="rmpResult.name" disabled placeholder="请输入成果名称" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="所属线路">
                            <a-input v-model="rmpResult.lineText" disabled placeholder="请输入成果名称" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="成果分类">
                            <a-input v-model="rmpResult.classificationText" disabled placeholder="请输入成果分类" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="数据来源">
                            <a-input v-model="rmpResult.sourceText" disabled placeholder="请输入数据来源" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-item label="发布时间">
                            <a-input v-model="rmpResult.publishTime" disabled placeholder="请输入发布时间" />
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </section>

        <section>
            <p class="section-title">成果摘要</p>
            <div v-html="rmpResult.abstractContent"></div>
        </section>

        <section style="display: flex;flex-direction: column;height: 100%;">
            <p class="section-title">研发成果描述</p>
            <div class="weboffice-node" style="height: 100%;"></div>
        </section>
    </div>
</template>
<script>
import WebOfficeSDK from '@/Utils/web-office-sdk-v1.1.19.es.js';
export default {
    data() {
        return {
            resultCode: '',
            resultName: '',
            lineCode: '',
            classification: '',
            sourceList: [
                { key: 1, text: '饲料研究院-水产料产品技术研发室' },
                { key: 2, text: '饲料研究院-猪料产品技术研发室' },
                { key: 3, text: '饲料研究院-反刍料产品技术研发室' },
                { key: 4, text: '饲料研究院-禽料产品技术研发室' },
            ],
            classList: [
                { key: 1, text: '研发成果类' },
                { key: 2, text: '技术方案总结类' },
                { key: 3, text: '新品种培育类' }
            ],
            lineList: [],
            rmpResult: {}
        };
    },
    created() {
        const _rmpResult = window.localStorage.getItem('rmpResult');
        if (!_rmpResult) {
            this.$router.push('/');
        } else {
            this.rmpResult = JSON.parse(_rmpResult);
            this.rmpResult.sourceText = this.sourceList.find(el => el.key === this.rmpResult.source).text;
        }
    },
    mounted() {
        this.getWPSData();
    },
    methods: {
        // 获取数据
        getWPSData() {
            this.$post('/nhf-app/formularmpresult/detailRmpResultVO', { rmpResultId: this.rmpResult.id }).then(res => {
                if (res.success) {
                    const webOfficeSdk = WebOfficeSDK.config({
                        url: res.data,
                        mode: 'simple',
                        mount: document.querySelector('.weboffice-node'),
                    });

                    webOfficeSdk.on('fileOpen', (data) => {
                        console.log('打开文档成功: ', data);
                    });

                    webOfficeSdk.on('webSocketStatus', (err) => {
                        console.log('error', err);
                    });
                }
            });
        },
    }
};
</script>

<style lang="scss" scoped>
section {
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 12px;

    .section-title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .headForm {
        padding: 0;
    }
}

.listContent {
    height: calc(100% - 41px);
    border-radius: 5px;

    .title_class {
        background-color: #fff;
        margin-bottom: 21px;
        border-radius: 5px;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .title_search_class {
            display: flex;
            flex-wrap: wrap;
            flex: 2;

            .search_change_class {
                display: flex;
                align-items: center;
                margin: 0 10px 10px 0;

                .text_class {
                    width: 100px;
                }
            }
        }

        .title_btn_class {
            flex: 0.6;

            .search_class {
                margin-right: 10px;
            }
        }
    }
}
</style>